// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/SubaccountsAnticipations_UpdateConfigInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for PUT /payments/anticipations/config/{subaccount_id}
 *
 * Updates anticipation configuration for a subaccount.
 */
import { registerContract } from './validate'

export interface SubaccountsAnticipations_UpdateConfigInput {
enabled?: boolean
auto_credit_card?: boolean
min_amount?: number
}

registerContract('SubaccountsAnticipations_UpdateConfigInput', {
  enabled:          { type: 'boolean', required: false },
  auto_credit_card: { type: 'boolean', required: false },
  min_amount:       { type: 'number',  required: false },
})
